export const userActionTypes = {
    /*
     * User create constants
     */
    CREATE_USER_REQUEST: 'USERS_CREATE_USER_REQUEST',
    CREATE_USER_SUCCESS: 'USERS_CREATE_USER_SUCCESS',
    CREATE_USER_FAILURE: 'USERS_CREATE_USER_FAILURE',

    /*
     * Login constants
     */
    LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
    LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
    LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',

    /*
     * LogOut status constants
     */
    LOGOUT: 'USERS_LOGOUT',

    /*
     * Get User constants
     */
    GET_USER_REQUEST: 'USERS_GET_USER_REQUEST',
    GET_USER_SUCCESS: 'USERS_GET_USER_SUCCESS',
    GET_USER_FAILURE: 'USERS_GET_USER_FAILURE',

    /*
     * Update payment info constants
     */
    SET_PAYMENT_REQUEST: 'SET_PAYMENT_REQUEST',
    SET_PAYMENT_SUCCESS: 'SET_PAYMENT_SUCCESS',
    SET_PAYMENT_FAILURE: 'SET_PAYMENT_FAILURE',

    /*
     * Validate username and password (Sign up)
     */
    REGISTRATION_VALIDATE_USER_CLEAR  : 'REGISTRATION_VALIDATE_USER_CLEAR',

    /*
     * User Password Reset Token Generation
     */
    PASSWORD_TOKEN_REQUEST: 'USERS_PASSWORD_TOKEN_REQUEST',
    PASSWORD_TOKEN_SUCCESS: 'USERS_PASSWORD_TOKEN_SUCCESS',
    PASSWORD_TOKEN_FAILURE: 'USERS_PASSWORD_TOKEN_FAILURE',

    /*
     * User Password Reset Process
     */
    PASSWORD_RESET_REQUEST: 'USERS_PASSWORD_RESET_REQUEST',
    PASSWORD_RESET_SUCCESS: 'USERS_PASSWORD_RESET_SUCCESS',
    PASSWORD_RESET_FAILURE: 'USERS_PASSWORD_RESET_FAILURE',

    /*
     * User Password Change Process
     */
    PASSWORD_CHANGE_REQUEST: 'USERS_PASSWORD_CHANGE_REQUEST',
    PASSWORD_CHANGE_SUCCESS: 'USERS_PASSWORD_CHANGE_SUCCESS',
    PASSWORD_CHANGE_FAILURE: 'USERS_PASSWORD_CHANGE_FAILURE',

    /*
     * User Account Cancellation
     */
    CANCEL_ACCOUNT_REQUEST: 'USERS_CANCEL_ACCOUNT_REQUEST',
    CANCEL_ACCOUNT_SUCCESS: 'USERS_CANCEL_ACCOUNT_SUCCESS',
    CANCEL_ACCOUNT_FAILURE: 'USERS_CANCEL_ACCOUNT_FAILURE',
};
